module.exports = __webpack_public_path__ + "img/14-xauat.e9204fc0.png";